export default "__VITE_ASSET__m1RRb$4B__"